/* Scent photo hero (sections/shoreline-photo-hero.liquid).

   Scroll drives a timeline over the pinned stage. Each photo carries
   data-ph-in, the scroll percent where it fades in over the one before;
   on wider screens photos ease out of a slight zoom while they are on screen.
     0-14    intro, front shot; the spray video (if set) plays over it as
             the page opens, or else at the spray stage
     15-34   the story, turned shot
     36-55   one spray: the top, heart and base notes in turn
     57-77   the scent over time: a clock from spraying to the dry-down,
             each note shown while it is noticeable on skin
     79-100  notes and the buy button, front shot
   Any overlay with data-b3-at="from,to" (percent) fades over its range.
   On phones the stage is not pinned: the overlays become cards scrolling
   under a sticky photo, and the percent comes from them (see cardsPc).

   Built for phones first: the stage follows the scroll exactly (no easing
   lag), does at most one update per frame, reads the DOM once up front and
   writes a style only when its value changes. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia && window.matchMedia('(max-width: 749px)');
  var FADE = 2.5;                       // photo crossfade, in scroll percent
  var LAYERS = [41.5, 45.5, 49.5];      // spray: when each note layer shows
  var SPRAY_END = 55.5;
  var VIDEO_LOAD = 18;                  // spray video: start fetching here
  var VIDEO_RESET = 30;                 // scrolled back above this: replay next time
  var OPEN_END = 12;                    // video on open: plays while above this
  var OPEN_RESET = 20;                  // scrolled past this: replay back at the top
  var CLOCK = [58, 75];                 // timeline: 0 h to the last hour

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function seg(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  // Writes a style property only when it changes: most frames change nothing.
  function put(el, prop, val) {
    var key = '__' + prop;
    if (el[key] === val) return;
    el[key] = val;
    el.style[prop] = val;
  }
  // A video that cannot play gives way to the still photo underneath.
  function dropVideo(root, v) {
    root.classList.remove('ph-wait');
    if (v.parentNode) v.parentNode.removeChild(v);
  }

  function PhotoHero(root) {
    var self = this;
    this.root = root;
    this.swatches = all(root, '[data-b3-swatch]');
    this.groups = all(root, '[data-b3-p]');
    this.items = all(root, '[data-b3-at]').map(function (el) {
      var a = el.getAttribute('data-b3-at').split(',');
      return { el: el, from: +a[0], to: +a[1] };
    });
    // Spray videos: with reduced motion the still photo underneath stays.
    // While one plays, the note names wait (.ph-wait) until its mist is out.
    all(root, '[data-ph-video]').forEach(function (v) {
      if (reduced) return v.parentNode.removeChild(v);
      var mist = parseFloat(v.getAttribute('data-ph-mist')) || 0;
      v.addEventListener('error', function () {
        // The lighter phone copy failed: try the full one before giving up.
        var full = v.getAttribute('data-src');
        if (v.__small && full) {
          v.__small = false;
          v.src = full;
          if (v.__played) self.start(v);
          return;
        }
        dropVideo(root, v);
        self.cache();
      }, true);
      // Shown only once it is really playing, so a slow start never flashes
      // an empty frame over the photo underneath.
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      v.addEventListener('timeupdate', function () {
        if (v.currentTime >= mist) root.classList.remove('ph-wait');
      });
      v.addEventListener('ended', function () { root.classList.remove('ph-wait'); });
    });
    this.cache();
    this.pc = -1;
    this.bind();
    this.frame();
  }

  // Everything render() touches, looked up once per perfume.
  PhotoHero.prototype.cache = function () {
    var set = this.root.querySelector('.ph__set.is-active');
    var group = this.root.querySelector('.b3__ui > .b3__p.is-active');
    var imgs = set ? all(set, '[data-ph-in]') : [];
    var ins = imgs.map(function (img) { return +img.getAttribute('data-ph-in'); });
    this.shots = imgs.map(function (img, k) {
      // Stays until the next shot that starts later: a video laid over the
      // photo it starts on shares that photo's stage.
      var next = 1e9;
      for (var j = k + 1; j < ins.length; j++) if (ins[j] > ins[k]) { next = ins[j]; break; }
      return {
        el: img,
        from: ins[k],
        next: next,
        // A video on open zooms with the photo under it, so they stay aligned.
        zoom: img.tagName !== 'VIDEO' || img.hasAttribute('data-ph-open')
      };
    });
    this.vid = set ? set.querySelector('[data-ph-video]') : null;
    this.layerEls = group ? all(group, '[data-b3-layer-name]') : [];
    var tl = group ? group.querySelector('.b3__tl') : null;
    this.tl = tl ? {
      max: parseFloat(tl.getAttribute('data-b3-max')) || 12,
      hour: tl.querySelector('[data-b3-hour]'),
      track: tl.querySelector('.b3__track'),
      mark: tl.querySelector('.b3__mark'),
      run: 0,
      notes: all(tl, '[data-b3-note]').map(function (li) {
        return { el: li, start: +li.getAttribute('data-start'), end: +li.getAttribute('data-end') };
      })
    } : null;
  };

  PhotoHero.prototype.bind = function () {
    var self = this;
    this.swatches.forEach(function (s, k) {
      s.addEventListener('click', function () { self.select(k, s); });
    });
    // The theme may scroll inside .page-wrapper rather than the window, and
    // scroll events do not bubble, so listen in the capture phase. Scroll
    // only asks for a frame; the frame does the reading and writing.
    var ask = function () { self.frame(); };
    document.addEventListener('scroll', ask, { passive: true, capture: true });
    window.addEventListener('resize', function () {
      if (self.tl) self.tl.run = 0;
      self.pc = -1;
      self.frame();
    }, { passive: true });
  };

  PhotoHero.prototype.frame = function () {
    if (this.queued) return;
    this.queued = true;
    var self = this;
    requestAnimationFrame(function () {
      self.queued = false;
      var rect = self.root.getBoundingClientRect();
      var vh = window.innerHeight;
      var cards = !!(narrow && narrow.matches);
      if (cards !== self.cards) self.setMode(cards);
      var pc;
      if (cards) {
        pc = self.cardsPc(vh);
      } else {
        var span = rect.height - vh;
        pc = span > 0 ? clamp(-rect.top / span, 0, 1) * 100 : 0;
      }
      // Lets the CSS keep the floating chat bubble off the hero's words.
      var on = rect.top < vh * 0.5 && rect.bottom > vh * 0.5;
      if (on !== self.on) {
        self.on = on;
        document.documentElement.classList.toggle('ph-hero-on', on);
      }
      // Off screen: nothing to draw.
      if (rect.bottom < 0 || rect.top > vh) return;
      if (pc === self.pc) return;
      self.pc = pc;
      self.render(pc);
    });
  };

  // Phones (card mode): the stage is not pinned. The words scroll up as cards
  // under the sticky photo, and the timeline position comes from the card
  // crossing a line in the middle of the open space below the photo: across
  // a card it runs through that card's data-b3-at range, and between two
  // cards from the end of one to the start of the next, so photos crossfade
  // in the gaps. Each card is revealed (.is-in) as it comes on screen.
  PhotoHero.prototype.setMode = function (cards) {
    this.cards = cards;
    this.pc = -1;
    // Card mode styles the words itself; drop what the pinned mode wrote.
    this.items.forEach(function (it) {
      ['opacity', 'transform', 'visibility'].forEach(function (p) {
        it.el.style[p] = '';
        it.el['__' + p] = undefined;
      });
      it.el.classList.remove('is-in');
    });
  };

  PhotoHero.prototype.cardsPc = function (vh) {
    var frame = this.root.querySelector('.ph__frame');
    var top = frame ? frame.getBoundingClientRect().bottom : 0;
    var line = top + (vh - top) * 0.45;
    var pc = 100; // past the last card
    var found = false;
    var prev = null;
    for (var k = 0; k < this.items.length; k++) {
      var it = this.items[k];
      var r = it.el.getBoundingClientRect();
      if (!r.height) continue; // hidden: the top line, another perfume
      // Revealed on the way in; hidden again only once fully below the
      // screen, so scrolling back up replays it.
      var inView = r.top < vh * 0.9 && r.bottom > top;
      if (inView !== it.in && (inView || r.top > vh)) {
        it.in = inView;
        it.el.classList.toggle('is-in', inView);
      }
      if (found) continue;
      if (line < r.top) {
        pc = prev ? prev.to + (it.from - prev.to) * clamp((line - prev.bottom) / (r.top - prev.bottom), 0, 1) : 0;
        found = true;
      } else if (line <= r.bottom) {
        pc = it.from + (it.to - it.from) * (line - r.top) / r.height;
        found = true;
      }
      prev = { to: it.to, bottom: r.bottom };
    }
    return pc;
  };

  PhotoHero.prototype.select = function (i, btn) {
    this.swatches.forEach(function (s, k) {
      s.classList.toggle('is-on', k === i);
      s.setAttribute('aria-pressed', k === i ? 'true' : 'false');
    });
    this.groups.forEach(function (g) { g.classList.toggle('is-active', +g.getAttribute('data-b3-p') === i); });
    if (btn.getAttribute('data-bg')) this.root.style.setProperty('--b3-bg', btn.getAttribute('data-bg'));
    if (btn.getAttribute('data-accent')) this.root.style.setProperty('--b3-accent', btn.getAttribute('data-accent'));
    this.cache();
    this.pc = -1;
    this.frame();
  };

  PhotoHero.prototype.render = function (pc) {
    // The slow zoom is for wider screens; phones only crossfade.
    var zoom = !reduced && !(narrow && narrow.matches);

    // Photos: each fades in over the one before and stays until the next is in.
    var cards = this.cards;
    this.shots.forEach(function (s) {
      var o = s.from <= 0 ? 1 : seg(pc, s.from - FADE, s.from);
      if (pc > s.next + 0.01) o = 0;
      // Card mode: a photo is either in or out and the CSS fades between
      // them, so stopping between two cards never leaves them half-blended.
      if (cards) o = o >= 0.5 ? 1 : 0;
      put(s.el, 'opacity', o.toFixed(2));
      put(s.el, 'visibility', o < 0.01 && !cards ? 'hidden' : 'visible');
      if (zoom && s.zoom && o > 0) {
        put(s.el, 'transform', 'scale(' + (1.04 - 0.04 * seg(pc, s.from - FADE, Math.min(s.next, 100))).toFixed(3) + ')');
      }
    });
    if (this.vid && this.vid.parentNode) this.video(this.vid, pc);

    if (!this.cards) this.items.forEach(function (it) {
      var fade = 3;
      var o = Math.min(seg(pc, it.from - fade, it.from + 0.01), 1 - seg(pc, it.to - 0.01, it.to + fade));
      if (it.from <= 0) o = 1 - seg(pc, it.to - 0.01, it.to + fade);
      if (it.to >= 100) o = seg(pc, it.from - fade, it.from + 0.01);
      o = clamp(o, 0, 1);
      put(it.el, 'opacity', o.toFixed(2));
      put(it.el, 'transform', 'translate3d(0,' + Math.round((1 - o) * 24) + 'px,0)');
      put(it.el, 'visibility', o < 0.01 ? 'hidden' : 'visible');
    });

    // Spray: the top, heart, then base notes
    var layer = pc < LAYERS[0] - 4 || pc > SPRAY_END ? -1 : pc >= LAYERS[2] ? 2 : pc >= LAYERS[1] ? 1 : 0;
    if (layer !== this.layer) {
      this.layer = layer;
      this.layerEls.forEach(function (el, k) { el.classList.toggle('is-on', k === layer); });
    }

    // Timeline: hour, marker, and the notes noticeable on skin now
    var tl = this.tl;
    if (tl && pc > CLOCK[0] - 3 && pc < CLOCK[1] + 3) {
      var h = seg(pc, CLOCK[0], CLOCK[1]) * tl.max;
      var shown = String(Math.floor(h + 0.0001));
      if (tl.hour && tl.hour.textContent !== shown) tl.hour.textContent = shown;
      // The marker slides by transform, not by its left edge, so moving it
      // never re-lays out the page. Its run is measured once per size.
      if (tl.mark && tl.track) {
        if (!tl.run) {
          var lab = parseFloat(getComputedStyle(tl.track).getPropertyValue('--lab')) || 0;
          tl.run = tl.track.clientWidth - lab;
        }
        put(tl.mark, 'transform', 'translate3d(' + (tl.run * h / tl.max).toFixed(1) + 'px,0,0)');
      }
      tl.notes.forEach(function (n) {
        var lit = h >= n.start && h <= n.end;
        if (n.lit !== lit) { n.lit = lit; n.el.classList.toggle('is-on', lit); }
      });
    }
  };

  // The spray video plays once, holding its last frame (the spray photo).
  // On open (data-ph-open) it loads straight away and plays while the intro
  // is on screen; scrolled past and back to the top, it plays again.
  // Otherwise it loads as the spray stage nears, plays on the way in, and
  // rewinds when scrolled back up. Phones get the lighter rendition.
  PhotoHero.prototype.video = function (v, pc) {
    var open = v.hasAttribute('data-ph-open');
    if (!v.getAttribute('src') && (open || pc > VIDEO_LOAD)) {
      var small = v.getAttribute('data-src-sm');
      v.__small = !!(small && narrow && narrow.matches);
      v.preload = 'auto';
      v.src = v.__small ? small : v.getAttribute('data-src');
    }
    var from = +v.getAttribute('data-ph-in');
    var inStage = open ? pc < OPEN_END : pc >= from - FADE && pc < SPRAY_END;
    var gone = open ? pc > OPEN_RESET : pc < VIDEO_RESET;
    if (inStage && !v.__played) {
      v.__played = true;
      this.start(v);
    } else if (gone && v.__played) {
      v.__played = false;
      this.root.classList.remove('ph-wait');
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    }
  };

  PhotoHero.prototype.start = function (v) {
    var root = this.root;
    if (+v.getAttribute('data-ph-mist') > 0) root.classList.add('ph-wait');
    try { v.currentTime = 0; } catch (e) {}
    var go = v.play();
    if (go && go.catch) go.catch(function (err) {
      // A new source mid-load aborts the old play(); the error handler
      // retries. Anything else (e.g. Low Power Mode): keep the photo.
      if (err && err.name === 'AbortError') return;
      dropVideo(root, v);
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-ph]').forEach(function (root) {
      if (!root.__ph) root.__ph = new PhotoHero(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
